// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1kCLW","label":"CategoryService_label__ulZmi","location":"CategoryService_location__1aMMJ"};